import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import HartSupportFooter from "./components/HartSupportFooter";

const HartPageWrapper = () => {
  return (
    <Box sx={{ minHeight: "100%", display: "flex", flexDirection: "column" }}>
      <Outlet />
      <Box sx={{ mt: "auto" }}>
        <HartSupportFooter />
      </Box>
    </Box>
  );
};

export default HartPageWrapper;
